var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("travelService.chooseOfferForm.title")))]),
      _vm.offer != null
        ? _c(
            "v-stepper",
            {
              attrs: { "non-linear": "" },
              model: {
                value: _vm.stepper,
                callback: function($$v) {
                  _vm.stepper = $$v
                },
                expression: "stepper"
              }
            },
            [
              _c(
                "v-stepper-header",
                [
                  _vm._l(_vm.offer.items, function(item, itemIndex) {
                    return [
                      _c(
                        "v-stepper-step",
                        {
                          key: item.id,
                          attrs: {
                            rules: [
                              function() {
                                return _vm.stepValidation(item)
                              }
                            ],
                            step: itemIndex + 1,
                            editable: "",
                            "error-icon": "fa-edit"
                          }
                        },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.$t("travelService.types." + item.type))
                            )
                          ]),
                          _vm.stepValidation(item) !== true
                            ? _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.chooseOfferForm.formIncomplete"
                                    )
                                  ) + " "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _c("v-divider", { key: -1 * item.id })
                    ]
                  }),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        step: _vm.offer.items.length + 1,
                        editable: "",
                        "error-icon": "fa-edit"
                      }
                    },
                    [_c("b", [_vm._v(_vm._s(_vm.$t("global.summary")))])]
                  )
                ],
                2
              ),
              _c(
                "v-stepper-items",
                [
                  _vm._l(_vm.offer.items, function(item, itemIndex) {
                    return _c(
                      "v-stepper-content",
                      { key: item.id, attrs: { step: itemIndex + 1 } },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form" + itemIndex,
                            refInFor: true,
                            model: {
                              value: item.isValid,
                              callback: function($$v) {
                                _vm.$set(item, "isValid", $$v)
                              },
                              expression: "item.isValid"
                            }
                          },
                          [
                            _vm._l(item.offers, function(offer, offerIndex) {
                              return _c("div", { key: offer.id }, [
                                _c(
                                  "fieldset",
                                  { staticClass: "custom-fieldset" },
                                  [
                                    _c("legend", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "travelService.chooseOfferForm.option"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(offerIndex + 1) +
                                          " "
                                      )
                                    ]),
                                    _c(
                                      "v-row",
                                      [
                                        offer.html != null &&
                                        offer.html.length !== 0
                                          ? _c(
                                              "v-col",
                                              { attrs: { md: "10" } },
                                              [
                                                _c(
                                                  "w-y-s-i-w-y-g-html-element",
                                                  {
                                                    attrs: { html: offer.html }
                                                  }
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.type === "hotel" &&
                                        (offer.html == null ||
                                          offer.html.length === 0)
                                          ? _c(
                                              "v-col",
                                              {
                                                attrs: { md: "10", cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "hotel-response-presentation",
                                                  { attrs: { offer: offer } }
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.type === "car" &&
                                        (offer.html == null ||
                                          offer.html.length === 0)
                                          ? _c(
                                              "v-col",
                                              {
                                                attrs: { md: "10", cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "car-response-presentation",
                                                  { attrs: { offer: offer } }
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.type === "flight" &&
                                        (offer.html == null ||
                                          offer.html.length === 0)
                                          ? _c(
                                              "v-col",
                                              {
                                                attrs: { md: "10", cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "flight-response-presentation",
                                                  { attrs: { offer: offer } }
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.type === "rail" &&
                                        (offer.html == null ||
                                          offer.html.length === 0)
                                          ? _c(
                                              "v-col",
                                              {
                                                attrs: { md: "10", cols: "12" }
                                              },
                                              [
                                                _c(
                                                  "rail-response-presentation",
                                                  { attrs: { offer: offer } }
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pl-3",
                                            attrs: { md: "2", cols: "12" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t("global.amount"),
                                                value:
                                                  offer.price +
                                                  " " +
                                                  offer.currency,
                                                outlined: "",
                                                readonly: ""
                                              }
                                            }),
                                            _c(
                                              "v-radio-group",
                                              {
                                                attrs: { mandatory: false },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.validateThisItemForm(
                                                      item
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: item.selectedOffer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "selectedOffer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.selectedOffer"
                                                }
                                              },
                                              [
                                                _c("v-radio", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "travelService.chooseOfferForm.chooseThis"
                                                    ),
                                                    value: offer.id
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            }),
                            _c("ClientViewOfferHistory", {
                              attrs: { offers: item.offers }
                            }),
                            _c(
                              "fieldset",
                              { staticClass: "custom-fieldset" },
                              [
                                _c("legend", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "travelService.additionalQuestions"
                                      )
                                    )
                                  )
                                ]),
                                _c("message-list", {
                                  attrs: {
                                    "travel-service-order-item-id": item.id,
                                    "travel-service-order-id":
                                      _vm.$route.params.id,
                                    "start-messages": item.messages
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pr-3",
                                    attrs: { md: "10", cols: "12" }
                                  },
                                  [
                                    _c(
                                      "v-alert",
                                      {
                                        staticClass: "text-justify",
                                        attrs: {
                                          color: "grey darken-2",
                                          outlined: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "travelService.chooseOfferForm.cancelRequest.firstPart"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/travel-service/edit/" +
                                                _vm.$route.params.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "travelService.chooseOfferForm.cancelRequest.linkPart"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "travelService.chooseOfferForm.cancelRequest.thirdPart"
                                              )
                                            ) +
                                            ' "'
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "travelService.chooseOfferForm.cancelRequest.boldPart"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          '". ' +
                                            _vm._s(
                                              _vm.$t(
                                                "travelService.separatePart"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.SeparateTravelService(
                                                  _vm.$route.params.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "travelService.separateLink"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(". ")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pl-1",
                                    attrs: { md: "2", cols: "12" }
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        attrs: { mandatory: false },
                                        on: {
                                          click: function($event) {
                                            item.returnSelectedOffer = 0
                                          }
                                        },
                                        model: {
                                          value: item.selectedOffer,
                                          callback: function($$v) {
                                            _vm.$set(item, "selectedOffer", $$v)
                                          },
                                          expression: "item.selectedOffer"
                                        }
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            label: _vm.$t(
                                              "travelService.chooseOfferForm.cancelRequest.radioLabel"
                                            ),
                                            value: 0
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            item.selectedOffer !== null &&
                            item.selectedOffer !== 0
                              ? _c(
                                  "v-row",
                                  [
                                    _c("travel-users-inline-form", {
                                      attrs: {
                                        "available-users": _vm.availableUsers,
                                        "required-props": _vm.getRequiredProps(
                                          item
                                        ),
                                        users: item.users
                                      },
                                      on: { saved: _vm.downloadAvailableUsers }
                                    }),
                                    _vm.$store.state.Auth.userProperties
                                      .system_settings
                                      .cost_centre_on_delegations !==
                                    _vm.settingTypes.NOT_AVAILABLE
                                      ? _c("v-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "fieldset",
                                            { staticClass: "custom-fieldset" },
                                            [
                                              _c("legend", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "travelService.chooseOfferForm.costCentreFullName"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]),
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-combobox",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.costCentres,
                                                                    rules:
                                                                      _vm.costCentresRules
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.cost_centre,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "cost_centre",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "item.cost_centre"
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      slot:
                                                                        "append"
                                                                    },
                                                                    slot:
                                                                      "append"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "fa-info-circle"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "travelService.chooseOfferForm.costCentreTooltipAny"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              color: "error darken-4",
                                              outlined: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "travelService.chooseOfferForm.checkData.firstPart"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "travelService.chooseOfferForm.checkData.boldPart"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "travelService.chooseOfferForm.checkData.thirdPart"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to:
                                                    "/travel-service/edit/" +
                                                    _vm.$route.params.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "travelService.chooseOfferForm.checkData.linkPart"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "travelService.chooseOfferForm.checkData.fourthPart"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  }),
                  _c(
                    "v-stepper-content",
                    { attrs: { step: _vm.offer.items.length + 1 } },
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("global.summary")))]),
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.summaryHeaders,
                          items: _vm.summaryDataTable,
                          "hide-default-footer": "",
                          "footer-props": {
                            "items-per-page-options": [
                              {
                                text: "$vuetify.dataIterator.rowsPerPageAll",
                                value: -1
                              }
                            ]
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function(props) {
                                return [
                                  _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(props.item.name) +
                                          " " +
                                          _vm._s(props.item.selectedOption)
                                      )
                                    ]),
                                    _c("td", {}, [
                                      _vm._v(
                                        _vm._s(props.item.selectedOptionCost)
                                      )
                                    ])
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1322999951
                        )
                      }),
                      _c(
                        "h3",
                        [
                          _vm._v(" " + _vm._s(_vm.$t("global.sum")) + ": "),
                          _vm._l(_vm.summaryDataTableCost, function(cost) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(cost.value) +
                                  " " +
                                  _vm._s(cost.currency) +
                                  " "
                              )
                            ]
                          }),
                          _vm.summaryDataTableCost.length === 0
                            ? [
                                _vm._v(
                                  " 0. " +
                                    _vm._s(
                                      _vm.$t(
                                        "travelService.noServicesSelectedToOrder"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.offer != null
        ? _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm.stepper === 1
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                      )
                    : _vm._e(),
                  _vm.stepper > 1
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.stepper--
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.back")))]
                      )
                    : _vm._e(),
                  _vm.stepper <= _vm.offer.items.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.stepper++
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.next")))]
                      )
                    : _vm._e(),
                  _vm.stepper === _vm.offer.items.length + 1
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: _vm.$store.getters["Ajax/loading"],
                            color: "blue darken-1",
                            text: ""
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }